// Map database IDs to friendly project names
const DB_DISPLAY_NAMES = {
  'pmd-preprod-db-gwa01': 'Global Wafers',
  'pmd-preprod-db-gfs01': 'GlobalFoundries',
  'pmd-preprod-db-pna01': 'Panasonic'
};

/**
 * Build report filename: "Project Name - Report Name - YYYYMMDDHHmmss.ext"
 */
const buildReportFilename = (reportName, extension) => {
  const dbId = localStorage.getItem('pmd-selected-database') || 'unknown';
  const dbName = DB_DISPLAY_NAMES[dbId] || dbId;

  const now = new Date();
  const timestamp = now.getFullYear().toString()
    + String(now.getMonth() + 1).padStart(2, '0')
    + String(now.getDate()).padStart(2, '0')
    + String(now.getHours()).padStart(2, '0')
    + String(now.getMinutes()).padStart(2, '0')
    + String(now.getSeconds()).padStart(2, '0');

  const safeName = reportName.replace(/[^a-zA-Z0-9 ]/g, '').trim();

  return `${dbName} - ${safeName} - ${timestamp}.${extension}`;
};

export default buildReportFilename;
